import React, { useEffect } from "react";
import moment from "moment";
// import AuthService from "../../services/auth.service";
// import { IdleTimeOutModal } from './IdleTimeOutModal'

const IdleTimeOutHandler = (props) => {
  // const [showModal, setShowModal] = useState(false);
  const isLogout = false;
  let timer = undefined;

  const events = ["click", "load", "keydown", "scroll", "mousemove"];
  const eventHandler = () => {
    if (!isLogout) {
      localStorage.setItem("lastInteractionTime", moment());
      if (timer) {
        props.onActive();
        startTimer();
      }
    }
  };

  useEffect(() => {
    addEvents();

    return () => {
      removeEvents();
      clearTimeout(timer);
    };
  }, []);

  const startTimer = () => {
    if (timer) {
      clearTimeout(timer);
    }
    timer = setTimeout(
      () => {
        let lastInteractionTime = localStorage.getItem("lastInteractionTime");
        const diff = moment.duration(
          moment().diff(moment(lastInteractionTime)),
        );
        let timeOutInterval = props.timeOutInterval
          ? props.timeOutInterval
          : 900000;
        // 900000
        if (isLogout) {
          clearTimeout(timer);
        } else {
          if (diff._milliseconds < timeOutInterval) {
            startTimer();
            props.onActive();
          } else {
            props.onIdle();
            // setShowModal(true);
            props.onLogout();
          }
        }
      },
      props.timeOutInterval ? props.timeOutInterval : 900000,
    );
  };
  const addEvents = () => {
    events.forEach((eventName) => {
      window.addEventListener(eventName, eventHandler);
    });

    startTimer();
  };

  const removeEvents = () => {
    events.forEach((eventName) => {
      window.removeEventListener(eventName, eventHandler);
    });
  };

  return <div></div>;
};

export default IdleTimeOutHandler;
